export enum LifecycleStatus {
    Approved = 'approved',
    Decommissioned = 'decommissioned',
    Decommissioning = 'decommissioning',
    Evaluating = 'evaluating',
    Implementing = 'implementing',
    NotConfigured = 'not_configured',
    Unapproved = 'unapproved'
}

export const LIFECYCLE = Object.values(LifecycleStatus);
